if (!customElements.get('variant-picker')) {
  customElements.define(
    'variant-picker',
    class VariantPicker extends HTMLElement {
      constructor() {
        super();
        this.abortController = null;
        this.init();
      }

      init() {
        this.bindEvents();
      }

      bindEvents() {
        this.addEventListener('change', this.handleVariantChange.bind(this));
      }

      handleVariantChange(event) {
        const target = event.target;
        if (target.type !== 'radio') return;

        const variantId = target.dataset.variantId;
        if (!variantId) return;

        this.fetchVariantData(variantId);
        target.value ? this.updateImage(target.value) : '';
        const newUrl = window.location.pathname + '?variant=' + variantId;
        window.history.replaceState(null, '', newUrl);
        const variantInputs = document.querySelectorAll('.product-info input[name="id"]');
        variantInputs.forEach(input => {
          input.value = variantId;
        });
      }

      async fetchVariantData(variantId) {
        if (this.abortController) {
          this.abortController.abort();
        }

        this.abortController = new AbortController();

        try {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('variant', variantId);
          const url = currentUrl.toString();
          
          const response = await fetch(url, {
            method: 'GET',
            signal: this.abortController.signal,
            headers: {
              'Accept': 'text/html',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          this.updatePrice(doc);
          this.updateConfigurator(doc);
          this.updateIncludedBlock(doc);

        } catch (error) {
          if (error.name === 'AbortError') return;
          console.error('Error fetching variant data:', error);
        }
      }

      updatePrice(doc) {
        const newPriceContainer = doc.querySelector('.product-info__price');
        if (!newPriceContainer) return;

        const currentPriceContainer = document.querySelector('.product-info__price');
        if (currentPriceContainer) {
          currentPriceContainer.innerHTML = newPriceContainer.innerHTML;
        }
      }

      updateImage(value) {
        if (!window.swiperProductThumbs || !window.swiperProductMain) {
          return;
        }
        
        const thumbsSlider = document.querySelector('.product-section .thumbs .swiper-wrapper');
        const mainSlider = document.querySelector('.product-section .swiper-main .swiper-wrapper');
        
        if (!thumbsSlider || !mainSlider) {
          return;
        }
        
        const thumbsSlides = Array.from(thumbsSlider.querySelectorAll('.swiper-slide'));
        const mainSlides = Array.from(mainSlider.querySelectorAll('.swiper-slide'));
        
        if (thumbsSlides.length === 0 || mainSlides.length === 0) {
          return;
        }
        
        let targetIndex = -1;
        
        for (let i = 0; i < thumbsSlides.length; i++) {
          const img = thumbsSlides[i].querySelector('img');
          if (img && img.alt === value) {
            targetIndex = i;
            break;
          }
        }
        
        if (targetIndex === -1) {
          for (let i = 0; i < mainSlides.length; i++) {
            const img = mainSlides[i].querySelector('img');
            if (img && img.alt === value) {
              targetIndex = i;
              break;
            }
          }
        }
        
        if (targetIndex === -1 || targetIndex === 0) {
          return;
        }
        
        const thumbsTargetSlide = thumbsSlides[targetIndex];
        const mainTargetSlide = mainSlides[targetIndex];
        const thumbsFirstSlide = thumbsSlides[0];
        const mainFirstSlide = mainSlides[0];
        
        thumbsTargetSlide.remove();
        mainTargetSlide.remove();
        thumbsFirstSlide.remove();
        mainFirstSlide.remove();
        
        thumbsSlider.insertBefore(thumbsTargetSlide, thumbsSlider.firstChild);
        mainSlider.insertBefore(mainTargetSlide, mainSlider.firstChild);
        
        thumbsSlider.appendChild(thumbsFirstSlide);
        mainSlider.appendChild(mainFirstSlide);
        
        window.swiperProductThumbs.update();
        window.swiperProductThumbs.slideTo(0);
        
        window.swiperProductMain.update();
        window.swiperProductMain.slideTo(0);
      }

      updateConfigurator(doc) {
        const configurator = document.querySelector('.product-info .product-section__configurator');
        const newConfigurator = doc.querySelector('.product-info .product-section__configurator');
        if (!configurator || !newConfigurator) return;

        configurator.innerHTML = newConfigurator.innerHTML;

        const configuratorModal = document.querySelector('#product-section .configurator-popup .configurator-popup__wrapper');
        const newConfiguratorModal = doc.querySelector('#product-section .configurator-popup .configurator-popup__wrapper');
        if (!configuratorModal || !newConfiguratorModal) return;

        configuratorModal.innerHTML = newConfiguratorModal.innerHTML;

        const form = document.querySelector('#product-section .product-form form');
        const newForm = doc.querySelector('#product-section .product-form form');
        if (!form || !newForm) return;

        form.innerHTML = newForm.innerHTML;

        const configuratorModalQnt = doc.querySelector('#product-section .configurator-popup').dataset.qnt;
        document.querySelector('#product-section .configurator-popup').dataset.qnt = configuratorModalQnt;
      }

      disconnectedCallback() {
        if (this.abortController) {
          this.abortController.abort();
        }
      }

      updateIncludedBlock(doc) {
        const includedBlock = document.querySelector('.product-section__included');
        const newIncludedBlock = doc.querySelector('.product-section__included');
        if (!includedBlock || !newIncludedBlock) return;

        includedBlock.innerHTML = newIncludedBlock.innerHTML;
      }
    }
  );
}